import React from 'react';
import { getIntl } from '../../../../../../../utils/intl';
import Stack from '../../../../../../v2BaseComponents/Stack';
import Icon from '../../../../../../v2BaseComponents/Icon';
import Text from '../../../../../../v2BaseComponents/Text';
import { APITypes } from '../../../../../../../primary-record-types';

const intl = getIntl('MultipleStatusSelectionDisplay', {
    message: 'Actions disabled due to conflicting client status',
});

export type MultipleStatusSelectionDisplayOwnProps = {};

export type MultipleStatusSelectionDisplayProps = MultipleStatusSelectionDisplayOwnProps;

const MultipleStatusSelectionDisplay: React.FC<MultipleStatusSelectionDisplayProps> = (_props) => {
    return (
        <Stack horizontal align="center" space={1}>
            <Icon name="AlertTriangle" size="button-icon" />
            <Text variant="body-1">{intl('message')}</Text>
        </Stack>
    );
};

export type UseRenderMultipleStatusSelectionDisplayArgs = {
    selectedClients: APITypes.organizationService.ListOrganizationClientRecordsResponse['items'];
};

export type UseRenderMultipleStatusSelectionDisplayReturnValue = {
    renderMultipleStatusSelectionDisplay: (() => React.ReactNode) | undefined;
};

export const useRenderMultipleStatusSelectionDisplay = ({
    selectedClients,
}: UseRenderMultipleStatusSelectionDisplayArgs) => {
    const statusCount = [...new Set(selectedClients.map((client) => client.status))].length;
    return {
        renderMultipleStatusSelectionDisplay: statusCount > 1 ? () => <MultipleStatusSelectionDisplay /> : undefined,
    };
};
